import ContentPagesMainContainer from '@/modules/ContentPages/containers/ContentPagesMainContainer/ContentPagesMainContainer';

const ContentPagesList = (): JSX.Element => {
  return <ContentPagesMainContainer />;
};

export default ContentPagesList;
